import React, { createContext, useContext, useEffect } from 'react';

type GlobalConfig = {
  googleApiKey: string | null;
  isLoading: boolean;
};

const GlobalConfigContext = createContext<GlobalConfig>({
  googleApiKey: null,
  isLoading: true,
});

export const GlobalConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [googleApiKey, setGoogleApiKey] = React.useState<string | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    const checkConfig = () => {
      if (window.globalConfig && window.globalConfig.GoogleApiKey) {
        setGoogleApiKey(window.globalConfig.GoogleApiKey);
        setIsLoading(false);
      } else {
        setTimeout(checkConfig, 100);
      }
    };
    checkConfig();
  }, []);

  return (
    <GlobalConfigContext.Provider value={{ googleApiKey, isLoading }}>
      {children}
    </GlobalConfigContext.Provider>
  );
};

export const useGlobalConfig = (): GlobalConfig => useContext(GlobalConfigContext);
